// extracted by mini-css-extract-plugin
export default {"base":"FooterNotes_base__OuIjM"};